import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { SimpleBarWrapper as SimpleBar } from 'desktop--design-library';
import { ApplicationStore, ApplicationStoreKey } from '../../liveStores';
import { EventDetailRawContainer } from '../liveEventDetail/eventDetailRawContainer';
import { FooterContainer } from '../footer/footerContainer';
import { translation, translationForMts } from 'easit--localization';
import { Instance } from 'mobx-state-tree';
import { FavoriteEventDetailsStore } from '../../models/live/favoriteEventDetails';
import { ProgressStateModel } from 'eTip--common';

export interface IFavoriteDetailsRouteProps {
    applicationStore?: Instance<typeof ApplicationStore>;
}

export interface IFavoriteDetailsRouteState {
    active: number[];
    showDetails: boolean;
}

export interface IRateSelectionEventParam {
    id: number;
    active: boolean;
}

@inject(ApplicationStoreKey)
@observer
export class FavoriteDetailsRouteContainer extends React.Component<IFavoriteDetailsRouteProps, IFavoriteDetailsRouteState> {

    constructor(props: IFavoriteDetailsRouteProps) {
        super(props);

        this.setShowDetail = this.setShowDetail.bind(this);
        this.state = {
            showDetails: false,
            active: []
        };
    }

    setShowDetail() {
        this.setState({
            showDetails: true
        });
    }

    componentWillMount() {
        this.props.applicationStore.setCanShowLeftColumn(true);

        this.props.applicationStore.favoriteDetails.initDetails(this.props.applicationStore.favoriteEventInfos.map(fid => fid.eventId));
        window.setTimeout(() => { this.setShowDetail(); }, 300); //hack to fix bug in SimpleBar - TODO - try to find better solution
    }

    get store(): Instance<typeof FavoriteEventDetailsStore> {
        return this.props.applicationStore.favoriteDetails;
    }

    get screenStore() {
        return this.props.applicationStore.screenInfo;
    }

    private removeEvent = (id: number): void => {
        this.props.applicationStore.removeFavoriteEvent(id);
    }

    private renderDetails = (): React.ReactNode => {

        const totalLiveStreams = this.state.showDetails && this.store.totalOpenLiveStreams;
        const totalMatchTrackers = this.state.showDetails && this.store.totalOpenMatchTrackers;

        return !this.state.showDetails ?
            null
            : (
                <div className={`masonry-container layout-columns-${this.screenStore.isXxlUp ? this.store.layoutColumns : 2}`}>
                    {
                        this.store.sortedDetails.map(
                            evt => {
                                let hasMatchTracker = this.props.applicationStore.events.eventsWithMatchTracker.has(evt.id);
                                return (
                                    <div className={`masonry-item ${evt.expanded ? 'expanded' : 'folded'}`} key={evt.id}>
                                        <SimpleBar className="h-100" scrollToTop>
                                            <EventDetailRawContainer
                                                key={evt.id}
                                                eventId={evt.id}
                                                store={evt}
                                                ticketWrapper={this.props.applicationStore.ticketWrapper}
                                                canShowInTabs={this.props.applicationStore.settingsProvider.canShowLiveEventDetailGroupTabs}
                                                canShowRemove={true}
                                                remove={() => { this.removeEvent(evt.id) }}
                                                moveToStart={() => { this.store.moveToStart(evt.id) }}
                                                moveToEnd={() => { this.store.moveToEnd(evt.id) }}
                                                isFavoriteDetail={true}
                                                canClearStoreOnUmount={false}
                                                isMatchTracker={hasMatchTracker}
                                                isMatchTrackerAllowed={totalMatchTrackers < 4
                                                    || evt.matchTracker && evt.matchTracker.state !== ProgressStateModel.NotInitialized
                                                /* either less than 4 or this event has mt already open */}
                                                matchTrackerClick={null}
                                                canOpenLiveStreamAfterLoad={false}
                                                isLiveStreamAllowed={totalLiveStreams < 2
                                                    || evt.liveStream && evt.liveStream.state !== ProgressStateModel.NotInitialized
                                                /* either less than 2 or this event has mt already open */}
                                                isDetailInList={false}
                                            />
                                        </SimpleBar>
                                        <div className="expand-toggle d-flex justify-content-end" >
                                            <div className={__IsMTSTipos__ ? "btn btn-primary" : "expand-toggle-button"} onClick={() => { evt.toggleExpand() }}>
                                                {evt.expanded ? translationForMts().liveFavorites_hideMoreDetails : translationForMts().liveFavorites_showMoreDetails}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        )
                    }
                </div>
            );
    }

    render() {
        //const { eventKey } = this.routeParams(this.props);
        return (
            <SimpleBar className="h-100" forceVisible={true} scrollToTop>
                {
                    this.store.sortedDetails.length > 0
                        ? <div className="cols-count-switch">
                            {
                                this.screenStore.isXxlUp &&
                                <>
                                    <span className={`cols-count-switch-item mr-1 ${this.store.layoutColumns === 2 ? 'selected' : ''}`}
                                        onClick={() => { this.store.setLayoutColumns(2); }}>||</span>
                                    <span className={`cols-count-switch-item mr-1 ${this.store.layoutColumns === 3 ? 'selected' : ''}`}
                                        onClick={() => { this.store.setLayoutColumns(3); }}>|||</span>
                                </>
                            }
                            <span className={`cols-count-switch-item `}
                                onClick={() => { this.props.applicationStore.removeAllFavoriteEvents() }}><span className="fa fa-times"></span></span>
                        </div>
                        : <div className="p-3"><span className="fa fa-info mr-2"></span>{translation().desktopLive_NoFavoriteEvents}</div>
                }
                {this.renderDetails()}
                <FooterContainer canShow={true} />
            </SimpleBar>
        );
    }
}
